import { DEMO_COMPLETE } from "../constants/ActionTypes";
import Cookies from "js-cookie";


var initialState = {
	complete: (Cookies.get("demoComplete") === "Y"),
};

export default function demo(state = initialState, action) {
	switch (action.type) {
	case DEMO_COMPLETE:
		Cookies.set("demoComplete", "Y", { expires : 10, path : "/" });
		return {
			...state,
			complete: true
		};
	default:
		return state;
	}
}



/** WEBPACK FOOTER **
 ** ./src/scripts/reducers/demo.js
 **/